import { render, staticRenderFns } from "./QTRMenu.vue?vue&type=template&id=5125c2b4"
import script from "./QTRMenu.vue?vue&type=script&lang=js"
export * from "./QTRMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports